import React from 'react';
import { PageHeader } from 'antd';
import { MyBreadcrumb } from 'utils';
import ClientsForm from './form';
export default function ClientsCreate() {

    return (
        <div>
            <MyBreadcrumb items={[{ label: "Resellers", path: "/clients" }, { label: "Create", path: "" }]} />
            <PageHeader
                ghost={false}
                onBack={() => window.history.back()}
                title="Create"
                subTitle=""
            >
                <ClientsForm />
            </PageHeader>
        </div>
    );
}